export const Home = () => {
 
    return (
            <div className="home"></div>
            )
}
